import * as types from '../actions';

export default function(state = [], action) {
  const response = action.response;
  let timeVar = '~~'+Date.now() 

  switch(action.type) {
    
    case types.CHANGE_PASSWORD_SUCCESS:
        if(response.status===200){
          return { ...state, 
            status: response.status,
            activity:types.CHANGE_PASSWORD_SUCCESS+timeVar,
            responseData: response.data
          }
        }
        else {
          return { ...state, 
            status: response.status,
            activity:types.CHANGE_PASSWORD_ERROR+timeVar,
            errorData: response.data, 
            responseData: response.data 
          }
        }

    case types.CHANGE_PASSWORD_ERROR:
      // return { ...state, response };
      return { ...state, 
        status: response.status,
        activity:types.CHANGE_PASSWORD_ERROR+timeVar, 
        errorData: response.data, 
        responseData: response.data 
      }
    default:
      return state;
  }
};